import { onError } from 'apollo-link-error';
import { ApolloErrorPayload, ApolloErrorType } from '../../../../../../types';
import { captureErrorSentry, captureEventSentry, SHOW_RECAPTCHA } from '../../../../../../utils';

import { ApolloNormalizedErrorPayload, ApolloAuthRequiredForSecondaryOpsPayload } from './types';
import {
	isAccessDeniedError,
	isAuthRequiredForSecondaryOps,
	isServerError,
	normalizeGraphQLError,
	pnrBlockedMessage,
	pnrBlockedRegExp,
	seatErrorRegExp,
	SeatNotAvailable,
	shouldIgnoreErrors
} from '@shared/error';
import {
	APOLLO_ACCESS_DENIED_ERROR_EVENT,
	APOLLO_AUTH_REQUIRED_FOR_SECONDARY_OPS_EVENT,
	APOLLO_NORMALIZED_ERROR_EVENT,
	APOLLO_ERRORS_EVENT,
	ignoredOperations
} from './constants';

const errorLink = onError(({ networkError, operation, graphQLErrors }) => {
	if (networkError && isServerError(networkError)) {
		const statusCode = networkError.statusCode;

		if (statusCode === 429) {
			// setTimeout гарантирует выполнение dispatchEvent после addEventListener
			setTimeout(() => document.dispatchEvent(new CustomEvent(SHOW_RECAPTCHA)));
		} else if (statusCode >= 500) {
			if (!ignoredOperations.has(operation.operationName) && !shouldIgnoreErrors(graphQLErrors)) {
				const event = new window.CustomEvent<ApolloErrorPayload>(APOLLO_ERRORS_EVENT, {
					detail: {
						operationName: operation.operationName,
						message: `${operation.operationName}: ${
							networkError.message ? networkError.message : `Server responded with code = ${statusCode}.`
						}`
					}
				});

				captureEventSentry(event);

				document.dispatchEvent(event);
			}
		}
	}

	if (graphQLErrors?.length > 0) {
		graphQLErrors.forEach(err => {
			if (pnrBlockedRegExp.test(err.message)) {
				const event = new window.CustomEvent<ApolloErrorPayload>(APOLLO_ERRORS_EVENT, {
					detail: {
						operationName: operation.operationName,
						message: pnrBlockedMessage,
						type: ApolloErrorType.PnrBlocked
					}
				});
				document.dispatchEvent(event);
			} else if (seatErrorRegExp.test(err.message)) {
				const event = new window.CustomEvent<ApolloErrorPayload>(APOLLO_ERRORS_EVENT, {
					detail: {
						operationName: operation.operationName,
						message: SeatNotAvailable
					}
				});
				document.dispatchEvent(event);
			} else if (isAuthRequiredForSecondaryOps(err)) {
				const event = new window.CustomEvent<ApolloAuthRequiredForSecondaryOpsPayload>(
					APOLLO_AUTH_REQUIRED_FOR_SECONDARY_OPS_EVENT,
					{
						detail: {
							operationName: operation.operationName,
							variables: operation.variables,
							operation: operation
						}
					}
				);
				document.dispatchEvent(event);
			} else if (isAccessDeniedError(err)) {
				const event = new window.CustomEvent<ApolloErrorPayload>(APOLLO_ACCESS_DENIED_ERROR_EVENT);
				document.dispatchEvent(event);

				captureErrorSentry('Access denied error');
			} else {
				const event = new window.CustomEvent<ApolloNormalizedErrorPayload>(APOLLO_NORMALIZED_ERROR_EVENT, {
					detail: {
						error: normalizeGraphQLError(err, operation)
					}
				});

				document.dispatchEvent(event);
			}
		});
	}
});

export default errorLink;
